// extracted by mini-css-extract-plugin
export default {"videoBox":"jtDevicePlayback_videoBox__L9Pj6","videoForm":"jtDevicePlayback_videoForm__pX+oB","videoPlay":"jtDevicePlayback_videoPlay__Yulem","resourceTable":"jtDevicePlayback_resourceTable__QDDWv","buttonPadding":"jtDevicePlayback_buttonPadding__Dx5yE"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"videoBox\":\"jtDevicePlayback_videoBox__L9Pj6\",\"videoForm\":\"jtDevicePlayback_videoForm__pX+oB\",\"videoPlay\":\"jtDevicePlayback_videoPlay__Yulem\",\"resourceTable\":\"jtDevicePlayback_resourceTable__QDDWv\",\"buttonPadding\":\"jtDevicePlayback_buttonPadding__Dx5yE\"}";
        // 1793760839034
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  